import {ConstraintsBuilder} from "./constraints-builder";

const Factory = {
    getBuilder() {
        return ConstraintsBuilder;
    }
}

export {Factory};